import { useState } from "react";
import { FalloutCharacter, MapAssetMoveable, PlaceMiniRequest, Vector3 } from "../Data/Response";
import styles from './PlaceMiniView.module.scss';

interface PlaceMiniViewArgs {
    unplacedCharacters: FalloutCharacter[];
    setPosition: (position: Vector3, characterId: string) => void;
}

const PlaceMiniView: React.FC<PlaceMiniViewArgs> = args => {
    return < div >
        <h1>Place Mini</h1>
        <p>Please place your character's mini on the battlefield.</p>
        <ul>
            {args.unplacedCharacters.map(pc => {
                return <SetMiniLocationListItem
                    characterId={pc.id}
                    characterName={pc.name}
                    setPosition={p => args.setPosition(p, pc.id)}
                />
            })}
        </ul>
    </div>
}

interface SetMiniLocationListItemArgs {
    characterId: string;
    characterName: string;
    setPosition: (position: Vector3) => void;
}

const SetMiniLocationListItem: React.FC<SetMiniLocationListItemArgs> = (args) => {
    const [xPos, setXPos] = useState(0);
    const [yPos, setYPos] = useState(0);
    const [zPos, setZPos] = useState(0);

    const posXId = `${args.characterId}PositionX`;
    const posYId = `${args.characterId}PositionY`;
    const posZId = `${args.characterId}PositionZ`;
    return <li className={styles.placeMiniCharacter}>
        <h3>{args.characterName}</h3>
        <ul>
            <li>
                <label htmlFor={posXId}>X position</label>
                <input id={posXId} type="text" value={xPos} onChange={e => setXPos(parseInt(e.target.value))}></input>
            </li>
            <li>
                <label htmlFor={posYId}>Y position</label>
                <input id={posYId} type="text" value={yPos} onChange={e => setYPos(parseInt(e.target.value))}></input>
            </li>
            <li>
                <label htmlFor={posZId}>Z position</label>
                <input id={posZId} type="text" value={zPos} onChange={e => setZPos(parseInt(e.target.value))}></input>
            </li>
            <li>
                <button onClick={e => {
                    args.setPosition({ X: xPos, Y: yPos, Z: zPos })
                }}>Set Mini Location</button>
            </li>
        </ul>
    </li>
}

export default PlaceMiniView;